// extracted by mini-css-extract-plugin
export default {"Gift":"Gift_Gift__126IM","Gift__icon":"Gift_Gift__icon__22ENN","Gift__count":"Gift_Gift__count__2MbSI"};